
<script>
import BarList from '../components/bar-list'
import EquipeForm from './equipe-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            equipe: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
        }
    },

    computed: {
        equipeList: function () {
            return this.$store.getters.getEquipeList
        },
    },

    methods: {
        usuariosEquipe(jsonUsuarios) {
            if (!jsonUsuarios) {
                return ''
            }

            let arr = JSON.parse(jsonUsuarios)
            let result = ''

            if (arr && arr.usuarios)
              for (var x = 0; x < arr.usuarios.length; x++) {
                  if (result !== '') {
                      result = result + ', '
                  }
                  result = result + arr.usuarios[x]
              }
            return result
        },

        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codequipe = cod
            this.showForm = true;
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codequipe = ''
            this.showForm = true;
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codequipe":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {            
            this.$store.dispatch('loadEquipe', { filter: this.filter, page: this.nextPage } )
            this.offset = ''
        }    

    },

    components: {
        BarList, EquipeForm
    },

    created () {
        this.showForm = false
        this.loadData()
    },

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false" 
                :xls-button="false"
                single-entity="Equipe" 
                plural-entity="Equipes"
                @search="search"
                @new="handleNew"
                @refresh="loadData">
            </bar-list>
            <br>
            <div class="default-container nb-card-list">
                <alert v-if="equipeList.length == 0" type="norecord"></alert>

                <article class="nb-card" v-for="equipe in equipeList" :key="equipe.codequipe">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-users" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ equipe.nome }}</h2>
                                </div>
                                <div class="nb-card-code" v-if="equipe.codequipe">
                                    Código <strong>{{ equipe.codequipe }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid 
                                :options="{barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar'}" 
                                :moreActions="[]" 
                                v-on:edit="handleEdit(equipe.codequipe)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-details" v-if="equipe.usuarios && equipe.usuarios.length">
                        <div class="nb-card-detail">
                            <span class="nb-card-detail-label">Membros da Equipe</span>
                            <strong><i class="fa fa-user-circle-o mr-1" aria-hidden="true"></i> {{ usuariosEquipe(equipe.usuarios) }}</strong>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <equipe-form v-if="showForm" :index="this.codequipe" :crud="this.crud" @closeform="closeForm"></equipe-form>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-details {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/equipe-list.vue